import axios from 'axios'

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '/api'
const http = axios.create({ baseURL: apiBaseUrl, timeout: 15000 })

export const getPortal = params => http.get('/portal', { params }).then(response => response.data)
export const submitInquiry = form => http.post('/portal/inquiries', form)
export const submitResume = form => http.post('/portal/contact/resume', form, { headers: { 'Content-Type': 'multipart/form-data' } })
export const loginAdmin = credentials => http.post('/auth/login', credentials).then(response => response.data)
export const getAdminSession = () => http.get('/auth/me', {
  headers: { Authorization: `Bearer ${localStorage.getItem('traout-admin-token') || ''}` }
}).then(response => response.data)
export const logoutAdmin = () => http.post('/auth/logout', null, {
  headers: { Authorization: `Bearer ${localStorage.getItem('traout-admin-token') || ''}` }
})
export const adminRequest = (method, path, data, params) => http.request({
  method,
  url: `/admin${path}`,
  data,
  params,
  headers: { Authorization: `Bearer ${localStorage.getItem('traout-admin-token') || ''}` }
}).then(response => response.data)
export const uploadAdminImage = file => {
  const form = new FormData()
  form.append('image', file)
  return http.post('/admin/images', form, {
    headers: { Authorization: `Bearer ${localStorage.getItem('traout-admin-token') || ''}` }
  }).then(response => response.data)
}
export const downloadAdminFile = (path, filename) => http.get(`/admin${path}`, {
  responseType: 'blob',
  headers: { Authorization: `Bearer ${localStorage.getItem('traout-admin-token') || ''}` }
}).then(response => {
  const url = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
})